var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPRect = function SvgPRect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p-rect_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.73v25.422h18.267V17.73H0Z",
    fill: "#418FDE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "p-rect_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h18v43H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p-rect_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.133 0C8.133 0 0 7.952 0 17.73h18.267v17.731c9.933-.065 18-7.953 18-17.731C36.2 7.952 28.133 0 18.133 0Z",
    fill: "#00BDFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.73c0 4.889 2 9.322 5.333 12.516a18.299 18.299 0 0 0 12.8 5.215h.134V17.73H0Z",
    fill: "#005BE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p-rect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v43H0z"
  })))));
};
export default SvgPRect;